













import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from './Icon.vue';

export interface ToggleOption {
  value: string;
  name: string;
  isSelected: boolean;
}

@Component({
  components: { Icon },
})
export default class Toggle extends Vue {
  @Prop({ required: true })
  options: ToggleOption[];

  @Prop({ required: true })
  onOptionChange: (value: string) => Promise<void>;

  async optionClicked(option: ToggleOption) {
    this.options.forEach(otherOption => {
      otherOption.isSelected = false;
    });

    option.isSelected = true;

    await this.onOptionChange(option.value);
  }
}
